import { actions } from '.';
import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import webApi from '../../../Lib/WebApi';
import { addErrorNotice, callApi, catchWithAuthErrors } from '../../Helpers/rxjsHelpers';

export const add = (action$) => {
  return action$.pipe(
    ofType(actions.addWorksheet.toString()),
    switchMap(({ payload: { sampleId, worksheetTypeId } = {} }) => {
      return callApi(
        webApi.worksheets.query.post({
          Body: {
            sampleId,
            worksheetTypeId,
          },
        })
      ).pipe(
        map((response) =>
          actions.addWorksheetResolve({
            worksheetId: response.Body.Id,
          })
        ),
        catchWithAuthErrors((err) => of(actions.addWorksheetReject(), addErrorNotice('Failed to add worksheet.', err)))
      );
    })
  );
};
